// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".err_msg[data-v-2128efef]{color:#cd0000;font-size:11px}", "",{"version":3,"sources":["webpack://./resources/js/Shared/ErrorMsg.vue"],"names":[],"mappings":"AACI,0BAEI,aAAA,CADA,cACR","sourcesContent":["\r\n    .err_msg{\r\n        font-size: 11px;        \r\n        color: #CD0000\r\n    }\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
